// extracted by mini-css-extract-plugin
module.exports = {"settingForm":"setting-form_settingForm_cIiWZ","manage":"setting-form_manage_1VHIR"};